/**
 * TelemetryService.js
 * Created by calhosh on 8/28/2020.
 */
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { Environment } from "../../../util";
import Utility from "../../../util/utilityFunctions";

let reactPlugin = null;
let appInsights = null;

/**
 * Create the App Insights Telemetry Service
 * @return {{reactPlugin: ReactPlugin, appInsights: Object, initialize: Function}} - Object
 */
const createTelemetryService = () => {
  /**
   * Initialize the Application Insights class
   * @param {string} connectionString - Application Insights Connection String
   * @return {void}
   */
  const initialize = (connectionString) => {
    if (!connectionString) {
      console.log(
        "Connection String key is not present in config file for specific environment for Application Insight"
      );
    }

    reactPlugin = new ReactPlugin();
    appInsights = new ApplicationInsights({
      config: {
        connectionString: connectionString,
        maxBatchInterval: 0,
        disableAjaxTracking: true, //
        disableFetchTracking: true,
        extensions: [reactPlugin],
        enableAutoRouteTracking: true,
        enableUnhandledPromiseRejectionTracking: Utility.convertToBoolean(
          Environment.getAppInsightsConfig().enableUnhandledPromiseRejectionTracking
        ),
      },
    });

    appInsights.loadAppInsights();
  };

  return { reactPlugin, appInsights, initialize };
};

export const ai = createTelemetryService();
export const getAppInsights = () => appInsights;
